import Env from '../base/env'
import Waypoint from '../vendor/waypoints'

export default class PlayerSimple
{
    constructor(view=null)
    {
        if(view != null)
        {
            this.view = view
            this.$views = this.view.querySelectorAll('.jsPlayer--view')
            this.players = []
            this.instancesAutoplay = []
            this.instancesWaypoints = []
            this.install()
        } else {
            return
        }
    }

    destroy()
    {
        if(typeof this.instancesAutoplay !== 'undefined') {
            for(let i = 0; i < this.instancesAutoplay.length; i++) {
                const instance = this.instancesAutoplay[i]
                instance.destroy()
            }
        }
    }

    install()
    {
        const viewport = Env.framework.toolbox.getViewport()
        for(let i = 0; i < this.$views.length; i++) {
            const $view = this.$views[i]
            const coordinatesView = $view.getBoundingClientRect()
            const $triggers = this.view.querySelectorAll('.jsPlayer--trigger')
            const $context = $view
            const $video = $view.querySelector('.jsPlayer--video')
            const $bgVideo = $view.querySelector('.jsPlayer--videoBg')
            const id = 'playerBody-'+Env.framework.toolbox.guid()
            let theplayer,options

            if(Env.mobile) {
                $video.setAttribute('controls','controls')
            }

             // check playing
             $video.addEventListener('play',()=>
             {
                 $bgVideo.pause()
                 $context.classList.remove('video--isPausing')
                 $context.classList.add('video--isPlaying')
                 for(let w = 0; w < this.players.length ; w++)
                 {
                     const player = this.players[w]
                     if(player.video.paused == false && w != i)
                     {
                         player.video.pause()
                     }
                 }
             },false)

             // check pausing
             $video.addEventListener('pause',()=>
             {
                 $context.classList.remove('video--isPlaying')
                 $context.classList.add('video--isPausing')
             },false)

             // check ended
             $video.addEventListener('ended',()=>
             {
                 if($context.classList.contains('video--isPausing')) $context.classList.remove('video--isPausing')
                 if($context.classList.contains('video--isPlaying')) $context.classList.remove('video--isPlaying')
             },false)

             // Event Play
            for(let w = 0; w < $triggers.length; w++) {
                 const $trigger = $triggers[w]
                  $trigger.addEventListener('click',()=>{
                    const status = $video.paused
                    if(status == true)
                    {
                        const playPromise = $video.play()
                        if (playPromise !== undefined) {
                            playPromise.then(_ => {
                                if(this.players[i].loaded == false)
                                {
                                    $video.volume = 1
                                    this.players[i].loaded = true
                                }
                            })
                            .catch(error => {
                                $context.classList.remove('video--isPlaying')
                                $context.classList.add('video--isPausing')
                            });
                        }
                    } else {
                        $video.pause()
                    }
                })
            }

            // Event Playpause
            $video.addEventListener('click',(event)=>{
                if($context.classList.contains('video--isPlaying')){
                    $video.pause();
                } else {
                    const playPromise = $video.play();
                    if (playPromise !== undefined) {
                        playPromise.then(_ => {

                        })
                        .catch(error => {

                        });
                    }
                }
            },false)

            $video.addEventListener('touchstart',()=>{
                $video.click()
            })

            // Scroll Top Point
            const instanceWaypointTop = new Waypoint({
                element: $view,
                handler: (direction)=> {
                    if(direction == "up") {
                        if($context.classList.contains('video--isPlaying')){
                            $video.pause()
                        }
                    }
                },
                offset:  '100%'
            });
            this.instancesWaypoints.push(instanceWaypointTop)

            // Scroll Bottom point
            const instanceWaypointBottom = new Waypoint({
                element: $view,
                handler: (direction)=> {
                    if(direction == "down") {
                        if($context.classList.contains('video--isPlaying')){
                            $video.pause()
                        }
                    }
                },
                offset: (coordinatesView.top - viewport.height) * -1
            });
            this.instancesWaypoints.push(instanceWaypointBottom)

            // Event autoplay
            if($context.classList.contains('jsWaypoint--autoplay') === true) {
                const offset = (typeof $context.getAttribute('data-offset') != 'undefined')?$context.getAttribute('data-offset'):'70%'
                const instanceAutoplay = new Waypoint({
                    element: $context,
                    handler: (direction)=> {
                        if(Env.mobile && Env.ios) {
                            $context.classList.add('video--iosAutoplay')
                            const $poster =  $context.querySelector('.poster')
                            const dimensions = $video.getBoundingClientRect()
                            if($poster != null) {
                                $video.poster = $poster.getAttribute('src')
                            }
                        } else {
                            if(direction == "down") {
                                $video.play()
                                setTimeout(() => {
                                    $context.classList.add('video--isPlaying')
                                }, 500);
                            }

                        }
                    },
                    offset: offset
                });
                this.instancesAutoplay.push(instanceAutoplay)
            }

            if($context.classList.contains('jsWaypoint--autoplay') === true) {
                if(Env.mobile && Env.ios) {
                    $context.addEventListener('click',()=>{
                        $video.play()
                        $context.classList.add('video--iosAutoplaying')
                    })
                }
            }

            // PLAYER
            this.players[i] = {}
            this.players[i].video = $video
        }
    }

    launchVideo($trigger)
    {
        let getIndex = $trigger.getAttribute('data-triggerindex')
        let theplayer = this.players[getIndex]
        if(typeof theplayer == 'object') {
            theplayer.getPlayerState().then((state)=>
            {
                if(state == 5 || state == 2)
                {
                    if(Env.mobile == true) {
                        setTimeout(() => {
                            this.$views[index].classList.add('video--isPlaying')
                        }, 200);

                    }
                    theplayer.playVideo()
                }
                else if(state == 1)
                {
                    theplayer.pauseVideo()
                }
            })
            return;
        }
    }
}


// WEBPACK FOOTER //
// ./resources/js/components/PlayerSimple.js